import type { CurriculumApi } from '@mathflat/domain/@entities/Curriculum/api'
import { Entity as CurriculumEntity } from '@mathflat/domain/@entities/Curriculum/dto'
import type { DefaultResponse } from '@mathflat/shared/@types/mathflatApi'

import maxios from '../utils/maxios'

export const curriculumApi = {
  getCurriculumCore: async () => {
    const { data } =
      await maxios.get<DefaultResponse<CurriculumApi.Response.CurriculumCore>>('/curriculums/core')
    return new CurriculumEntity.CurriculumCore(data)
  },

  getCurriculum: async (ids: number[], type: 'CONCEPT' | 'LITTLE_CHAPTER') => {
    const { data } = await maxios.get<DefaultResponse<CurriculumApi.Response.CurriculumInfo[]>>(
      `/curriculums`,
      {
        params: {
          idSet: ids,
          type,
        },
      },
    )
    return data
  },

  getCurriculumChaptersBySearch: async (curriculumKey: string, bigChapterName: string) => {
    const { data } = await maxios.get<DefaultResponse<CurriculumApi.Response.ChaptersBySearch>>(
      `/curriculums/middle-chapters`,
      {
        params: { bigChapterName, curriculumKey },
      },
    )
    return data
  },
}
